import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import Workspace from './workspace/reducers';

export default combineReducers({
    Auth,
    Layout,
    Workspace,
});
